import { ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { Modal } from 'react-bootstrap'
import { HStack, VStack } from '../../../../utils/Stack'
type LogoutModalProps = {
  showModal: boolean
  handleBack: Function
  handleSubmit: Function
}
export function LogoutModal(props: LogoutModalProps) {
  return (
    <Modal
      id='kt_modal_add_inv'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-525px '
      show={props.showModal}
      onHide={() => props.handleBack()}
    >
      <Modal.Body className='p-6'>
        <div className='card'>
          <div className='card-body p-0'>
            <HStack className='gap-6 d-flex align-items-center'>
              <ExclamationTriangleIcon
                className='h-40px w-40px text-danger p-2 bg-danger bg-opacity-10 rounded-circle'
                aria-hidden='true'
              />
              <VStack className=''>
                <div className='fs-4 pb-2 fw-bold'>Log out</div>
                <div className='fs-5 fw-normal pb-2 text-gray-600'>
                  Are you sure you want to logout your account?
                </div>
              </VStack>
            </HStack>

            <div className='d-flex col justify-content-end pt-4 gap-4'>
              <button
                className='px-4 rounded border border-1 border-gray-600 bg-transparent h-38px fw-normal text-gray-800 fw-bold bg-hover-secondary'
                onClick={() => props.handleBack()}
              >
                <span className='indicator-label'>Cancel</span>
              </button>
              <button
                type='submit'
                className='px-4 rounded border border-0 border-primary bg-danger-active h-38px fw-normal text-white fw-bold bg-hover-opacity-90'
                onClick={() => props.handleSubmit()}
              >
                Log out
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}
